import React from 'react';
import { useLanguage } from '../LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <section className="about-section" id="about">
      <div className="about-content">
        <div className="about-heading">
          <span className="about-icon" aria-hidden="true">
            <img src="/images/plane-icon.webp" alt="Plane icon" />
          </span>
          <h2>{t.about.title}</h2>
        </div>
        {t.about.paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
};

export default About;
